export const SYNC_INVALID_REQUEST = 'SYNC_INVALID_REQUEST';
export const SYNC_COMPANY_MISMATCH = 'SYNC_COMPANY_MISMATCH';
export const SYNC_UNSUPPORTED_EVENT_TYPE = 'SYNC_UNSUPPORTED_EVENT_TYPE';
export const SYNC_DUPLICATE_EVENT_MISMATCH = 'SYNC_DUPLICATE_EVENT_MISMATCH';
export const SYNC_CLIENT_ID_REQUIRED = 'SYNC_CLIENT_ID_REQUIRED';
export const SYNC_CURSOR_INVALID = 'SYNC_CURSOR_INVALID';
export const HOLDING_UNITS_CANONICAL_BOOTSTRAP_RESTART_REQUIRED =
  'HOLDING_UNITS_CANONICAL_BOOTSTRAP_RESTART_REQUIRED';
export const SYNC_DEPENDENCY_MISSING = 'SYNC_DEPENDENCY_MISSING';
export const SYNC_STATION_CLOUD_SYNC_REQUIRED = 'SYNC_STATION_CLOUD_SYNC_REQUIRED';
export const SYNC_STATION_RECOVERED_ON_ANOTHER_DEVICE = 'SYNC_STATION_RECOVERED_ON_ANOTHER_DEVICE';
export const SYNC_ACTOR_INVALID = 'SYNC_ACTOR_INVALID';
export const SYNC_RESULT_PROTOCOL_INVALID = 'SYNC_RESULT_PROTOCOL_INVALID';
export const SYNC_TRANSACTION_CONFLICT = 'SYNC_TRANSACTION_CONFLICT';
export const SYNC_STATION_BINDING_INVALID = 'SYNC_STATION_BINDING_INVALID';
export const OUTBOX_DEPENDENCIES_UNRESOLVED = 'OUTBOX_DEPENDENCIES_UNRESOLVED';
export const OUTBOX_STREAM_LOCAL_GAP = 'OUTBOX_STREAM_LOCAL_GAP';
export const OUTBOX_ACKED_PREDECESSOR_CLOUD_BEHIND = 'OUTBOX_ACKED_PREDECESSOR_CLOUD_BEHIND';
export const OUTBOX_PAYLOAD_UNSUPPORTED = 'OUTBOX_PAYLOAD_UNSUPPORTED';
export const LEGACY_VERSION_CONFLICT_RECHECK_REQUIRED = 'LEGACY_VERSION_CONFLICT_RECHECK_REQUIRED';
export const INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR';
